import { render } from "./BirthdayInput.vue?vue&type=template&id=70c1489d"
import script from "./BirthdayInput.vue?vue&type=script&lang=js"
export * from "./BirthdayInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__